import PageTitle from "../ui/PageTitle";

import { EventForm } from "./EventForm";

const NewEvent = () => {
  return (
    <>
      <div className="page-div">
        <div className="title-area w-full">
          <PageTitle
            title="Create Event"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "event", path: "/event" },
              { name: "new", path: "/event/new" },
            ]}
          />
        </div>
        <EventForm event={null} />
      </div>
    </>
  );
};

export default NewEvent;
